module.exports = __webpack_public_path__ + "img/tpc-31.362abd83.jpg";